<template>
  <div>  
  <!--================ Offer section start =================-->      
  <section class="section-margin">
    <div class="container">
      <div class="section-intro pb-85px text-center">
        <h2 class="section-intro__title">Solution for Banks & Insurance</h2>
        <p class="section-intro__subtitle">
            Many companies spends tons of money and effort the get visitors to convert.
            But when they convert, many of the companies forgets about them or reach out in the blind.
            With RetainerDesk you can get more value out of your investment by understanding customers and make your product even better.
            If your customer churns you have all the data from start to end and also the data where the risk appeared and why.
        </p>
      </div>

      <div class="row">
        <div class="col-lg-6">

          <div class="row offer-single-wrapper">
            <div class="col-lg-6 offer-single">
              <div class="card offer-single__content text-center">
                <span class="offer-single__icon">
                  <i class="ti-wand"></i>
                </span>
                <h4>Cancelletion checkout</h4>
                <p>If a customer want to cancel their subscription they will go through the Retention Flow, where we gather data on why they want to cancel.</p>
              </div>
            </div>
            
            <div class="col-lg-6 offer-single">
              <div class="card offer-single__content text-center">
                <span class="offer-single__icon">
                  <i class="ti-signal"></i>
                </span>
                <h4>Find risk customers early</h4>
                <p>The system automaticly identify users that are in certain kategories. Connect with your users based on the label directly in the system.</p>
              </div>
            </div>
          </div>

          <div class="row offer-single-wrapper">
            <div class="col-lg-6 offer-single">
              <div class="card offer-single__content text-center">
                <span class="offer-single__icon">
                  <i class="ti-direction-alt"></i>
                </span>
                <h4>Marketing campaings</h4>
                <p>Understand which marketing campaign that made less churn, and the marketing campaigns that make customers churn.</p>
              </div>
            </div>
            
            <div class="col-lg-6 offer-single">
              <div class="card offer-single__content text-center">
                <span class="offer-single__icon">
                  <i class="ti-id-badge"></i>
                </span>
                <h4>Screen recordings</h4>
                <p>Every interaction is recorded and labeled with labels that make you understand which recording to watch.</p>
              </div>
            </div>
          </div>

        </div>
        <div class="col-lg-6">
          <div class="offer-single__img">
            <img class="img-fluid" src="@/assets/ret_pn.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--================ Offer section end =================-->

      <!--================ about section start =================-->      
    <section class="section-padding--small bg-magnolia">
      <div class="container">
        <div class="row">
          <div class="col-md-5 mb-5 mb-md-0">
            <div class="solution__content">
              <h2>See your customers moving from risk to neutral</h2>
              <p>We offer a unique insight about your customers. Prioritize which customer to focus on first and make them happy. You'll know exactly who is doing what and you will also get risk insights such as:
              <br><br>
              ~ Low activity<br>
              ~ Spam clicks<br>
              ~ Keyboard rage<br>
              ~ Long time since last visits<br>
              ~ Risky behaviour.
    
              </p>
              <a class="button button-light button-blue" href="/pricing">Choose Your Plan</a>
            </div>
          </div>
          <div class="col-md-7">
            <div class="offer-single__img" style="box-shadow: 0px 3px 15px -9px rgba(0,0,0,0.75); margin-top:-20px;">
                    <img class="img-fluid" style="margin-top:-2px; padding:0px; width:101%;" src="@/assets/top_safar_retainerdesk.png" alt="">
                    <img class="img-fluid" style="margin-top:0%;" src="@/assets/picture2.png" alt="">
            </div>
          </div>
        </div>
        

      </div>
    </section>
        <section class="section-padding--small bg-white">
      <div class="container">

            <div class="section-intro pb-5 text-center" style="">
          <h2 class="section-intro__title">Try RetainerDesk for free today!</h2>
          <p class="section-intro__subtitle">14 day free trial - cancel anytime - No credit card required</p>
          <br>
          <a class="button button-light button-blue" href="https://app.retainerdesk.com/#/register">Try it free</a>

        </div>
      </div>
    </section> 


    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>